module.exports = __webpack_public_path__ + "img/logo.fdb04cf6.png";